function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import Select from "react-select";
import styled, { withTheme } from "styled-components";
import InputError from "../input-error";
import Label from "../label";
import { context } from "../wr-context";
import { MutedText } from "../text";
var DropdownContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.dropdownInput) === null || ref === void 0 ? void 0 : ref.container;
});
var DropdownInput = function(_param) {
    var fullWidth = _param.fullWidth, large = _param.large, label = _param.label, helpText = _param.helpText, options = _param.options, onChange = _param.onChange, value = _param.value, error = _param.error, isSearchable = _param.isSearchable, isMulti = _param.isMulti, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "Select an option" : _placeholder, catalogTheme = _param.theme, closeMenuOnSelect = _param.closeMenuOnSelect, hideSelectedOptions = _param.hideSelectedOptions, color = _param.primaryColor, menuIsOpen = _param.menuIsOpen, getSelectRef = _param.getSelectRef, className = _param.className, classNamePrefix = _param.classNamePrefix, onMenuClose = _param.onMenuClose, onMenuOpen = _param.onMenuOpen, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _hideLabel = _param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, _components = _param.components, components = _components === void 0 ? {} : _components, styles = _param.styles, rest = _objectWithoutProperties(_param, [
        "fullWidth",
        "large",
        "label",
        "helpText",
        "options",
        "onChange",
        "value",
        "error",
        "isSearchable",
        "isMulti",
        "placeholder",
        "theme",
        "closeMenuOnSelect",
        "hideSelectedOptions",
        "primaryColor",
        "menuIsOpen",
        "getSelectRef",
        "className",
        "classNamePrefix",
        "onMenuClose",
        "onMenuOpen",
        "isDisabled",
        "hideLabel",
        "components",
        "styles"
    ]);
    var ref;
    var primaryColor = color || catalogTheme.palette.primary;
    var utils = context.utils, constants = context.constants;
    var dropdownInput = constants.dropdownInput;
    return /*#__PURE__*/ React.createElement(DropdownContainer, {
        large: large,
        fullWidth: fullWidth,
        className: "dropdown-input"
    }, /*#__PURE__*/ React.createElement("label", null, label && !hideLabel && /*#__PURE__*/ React.createElement(Label, null, label), helpText && /*#__PURE__*/ React.createElement(MutedText, null, helpText), /*#__PURE__*/ React.createElement(Select, _extends({
        options: options,
        onChange: onChange,
        value: value || "",
        placeholder: placeholder,
        noOptionsMessage: dropdownInput.components.NoOptionsMessage,
        isSearchable: isSearchable || dropdownInput.isSearchable,
        isMulti: isMulti,
        menuIsOpen: menuIsOpen,
        components: components,
        ref: getSelectRef,
        isDisabled: isDisabled,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        closeMenuOnSelect: closeMenuOnSelect,
        openMenuOnFocus: true,
        hideSelectedOptions: hideSelectedOptions,
        className: className,
        classNamePrefix: classNamePrefix,
        filterOption: utils.dropdownInput.filteringFn,
        styles: (ref = catalogTheme.components.dropdownInput) === null || ref === void 0 ? void 0 : ref.styles,
        theme: function(theme) {
            var ref;
            return _objectSpreadProps(_objectSpread({}, theme), {
                borderRadius: "".concat((ref = catalogTheme.components.dropdownInput) === null || ref === void 0 ? void 0 : ref.borderRadius),
                colors: _objectSpreadProps(_objectSpread({}, theme.colors), {
                    primary: "".concat(primaryColor)
                }),
                spacing: _objectSpreadProps(_objectSpread({}, theme.spacing), {
                    controlHeight: "".concat(large) ? 45 : theme.spacing.controlHeight
                })
            });
        }
    }, rest)), error && /*#__PURE__*/ React.createElement(InputError, null, error)));
};
export default withTheme(DropdownInput);
